import { cn } from "@/lib/utils";

const STYLES = {
  success: "bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]",
  approved: "bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]",
  completed: "bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]",
  active: "bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]",
  confirmed: "bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]",
  done: "bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]",
  warning: "bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400",
  pending: "bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400",
  requested: "bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400",
  review_required: "bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400",
  in_progress: "bg-blue-50 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400",
  info: "bg-blue-50 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400",
  todo: "bg-blue-50 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400",
  error: "bg-red-50 text-red-600 dark:bg-red-500/15 dark:text-red-400",
  overdue: "bg-red-50 text-red-600 dark:bg-red-500/15 dark:text-red-400",
  critical: "bg-red-50 text-red-600 dark:bg-red-500/15 dark:text-red-400",
  draft: "bg-slate-100 text-slate-500 dark:bg-slate-500/15 dark:text-slate-400",
  inactive: "bg-slate-100 text-slate-500 dark:bg-slate-500/15 dark:text-slate-400",
  neutral: "bg-slate-100 text-slate-500 dark:bg-slate-500/15 dark:text-slate-400",
};

const LABELS = {
  review_required: "Review Required",
  in_progress: "In Progress",
  treatment_plan: "Treatment Plan",
};

export function StatusBadge({ status, label, className }) {
  const key = (status || "neutral").toLowerCase();
  const text = label || LABELS[key] || (status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2.5 py-0.5 text-[11px] font-semibold capitalize",
        STYLES[key] || STYLES.neutral,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {text}
    </span>
  );
}
